//
// Room
//
import { Entity } from "../../common/entity";
import { z } from "zod";
export const WorkspaceRoom = Entity.extend({
    workspaceId: z.string(),
    liveblocksId: z.string(),
});
